module.exports = __webpack_public_path__ + "static/green_hag-687f4e6a6f135d9e2b194662f879c56d.jpg";